// TimelessXI: recently viewed products. Handles live in this browser's localStorage only.
if (!customElements.get('txi-recently-viewed')) {
  customElements.define(
    'txi-recently-viewed',
    class TxiRecentlyViewed extends HTMLElement {
      static KEY = 'txi:recently-viewed';
      static MAX = 12;

      connectedCallback() {
        const current = this.dataset.handle;
        const limit = parseInt(this.dataset.limit, 10) || 4;
        const list = this.read();
        this.toShow = list.filter((h) => h !== current).slice(0, limit);
        this.write([current, ...list.filter((h) => h !== current)].slice(0, TxiRecentlyViewed.MAX));
        if (!this.toShow.length) return;

        if (!('IntersectionObserver' in window)) return this.load();
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        observer.observe(this);
      }

      read() {
        try {
          const value = JSON.parse(window.localStorage.getItem(TxiRecentlyViewed.KEY));
          return Array.isArray(value) ? value.filter((h) => typeof h === 'string') : [];
        } catch (e) {
          return [];
        }
      }

      write(list) {
        try {
          window.localStorage.setItem(TxiRecentlyViewed.KEY, JSON.stringify(list));
        } catch (e) {
          /* storage unavailable (private mode etc.) — feature just stays hidden */
        }
      }

      async load() {
        const base = this.dataset.url;
        const results = await Promise.all(
          this.toShow.map((handle) =>
            fetch(`${base}${encodeURIComponent(handle)}?section_id=txi-product-card`)
              .then((r) => (r.ok ? r.text() : ''))
              .catch(() => '')
          )
        );
        const grid = this.querySelector('ul');
        const parser = new DOMParser();
        const kept = [];
        results.forEach((html, i) => {
          if (!html) return;
          const card = parser.parseFromString(html, 'text/html').querySelector('.shopify-section > *');
          if (!card) return;
          const li = document.createElement('li');
          li.className = 'grid__item';
          li.append(card);
          grid.append(li);
          kept.push(this.toShow[i]);
        });
        // forget products that no longer exist
        if (kept.length !== this.toShow.length) {
          const gone = this.toShow.filter((h) => !kept.includes(h));
          this.write(this.read().filter((h) => !gone.includes(h)));
        }
        if (grid.children.length) this.hidden = false;
      }
    }
  );
}
